import { render } from "./VirtualShow.vue?vue&type=template&id=48f0b2ac&scoped=true"
import script from "./VirtualShow.vue?vue&type=script&lang=js"
export * from "./VirtualShow.vue?vue&type=script&lang=js"

import "./VirtualShow.vue?vue&type=style&index=0&id=48f0b2ac&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f0b2ac"]])

export default __exports__